import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../locales/en/translation.json';
import frTranslation from '../locales/fr/translation.json';
// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: enTranslation,
    },
    fr: {
        translation: frTranslation,
    },
};

const languageDetector = new LanguageDetector(null, {
    order: ['htmlTag', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'queryString', 'path', 'subdomain'],
});
// const languageDetector = new LanguageDetector(null, {
//     lookupCookie: 'wp-wpml_current_language',
// });

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .use(languageDetector)
    .init({
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
